module.exports = __webpack_public_path__ + "img/20110201_04.95059feb.jpg";